import { SmartDataTable } from '@src/components/SmartDataTable';
import { useMedicinesColumns, useMedicinesFormFields } from './hooks';

export const MedicinesPage = () => {
  const columns = useMedicinesColumns();
  const formFields = useMedicinesFormFields();

  return (
    <SmartDataTable
      api={{
        resource: 'medicines',
      }}
      title="Medicines"
      columns={columns}
      search={{
        enabled: true,
        fields: ['id', 'name', 'hsn', 'manufacturer', 'search_term'],
        placeholder: 'Search by name, HSN, or manufacturer...',
        debounceMs: 500,
      }}
      createForm={{
        fields: formFields as any,
        title: 'Add New Medicine',
        submitText: 'Add Medicine',
      }}
      editForm={{
        fields: formFields as any,
        title: 'Edit Medicine',
        submitText: 'Save Changes',
      }}
      formDisplayMode="modal"
      showCreate={true}
      showEdit={true}
      showDelete={true}
      showView={false}
      pageSize={10}
      showSizeChanger={true}
      showQuickJumper={false}
      // showExport={true}
      showColumnVisibility={true}
      tableProps={{
        scroll: {
          x: 'max-content',
          y: 'calc(100vh - 300px)',
        },
      }}
      rowKey="id"
    />
  );
};
